import type { FunctionComponent } from 'react';

import { Image } from '@/domains/core/Image/Image';
import { getPlatform } from '@/domains/core/settings/utils';
import { Accordion } from '@/domains/retention/Footer/modules/Accordion/Accordion';
import { footerContactSocialNetworkTitle } from '@/domains/retention/Footer/translations';

import Facebook from './assets/facebook.svg?url';
import Instagram from './assets/instagram.svg?url';
import Linkedin from './assets/linkedin.svg?url';
import Pinterest from './assets/pinterest.svg?url';
import Youtube from './assets/youtube.svg?url';
import { socialNetworksLinks } from './constants';

const getSocialMediaIconPath = (id: any) => {
  switch (id) {
    case 'facebook':
      return Facebook;
    case 'instagram':
      return Instagram;
    case 'linkedin':
      return Linkedin;
    case 'pinterest':
      return Pinterest;
    case 'youtube':
      return Youtube;
    default:
      return '';
  }
};

export const SocialMedia: FunctionComponent = () => (
  <div className="mt-l">
    <Accordion title={footerContactSocialNetworkTitle} isExpandable={false}>
      <div className="flex gap-m">
        {socialNetworksLinks[getPlatform()].map(
          ({ id, dataQa, href, name }) => (
            <a
              key={id}
              className="relative inline-block size-[32px] overflow-hidden
                text-foundation-inverted underline"
              href={href}
              rel="noopener noreferrer"
              target="_blank"
              aria-label={name}
              data-testid={dataQa}
            >
              <Image
                className="absolute ml-0 h-auto w-full"
                src={getSocialMediaIconPath(id)}
                alt={name}
                title={name}
                width={32}
                height={88}
              />
            </a>
          ),
        )}
      </div>
    </Accordion>
  </div>
);

SocialMedia.displayName = 'SocialMedia';
